import { render, staticRenderFns } from "./studentL.vue?vue&type=template&id=4b2d5e0e&scoped=true&"
import script from "./studentL.vue?vue&type=script&lang=js&"
export * from "./studentL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d5e0e",
  null
  
)

export default component.exports